import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { MEActivityService } from 'src/app/common/activities/me-activity.service';
import { ExternalSettings } from 'src/app/common/services/external-settings/external-settings.interface';
import { ExternalSettingsService } from 'src/app/common/services/external-settings/external-settings.service';
import { InternalSettings } from 'src/app/common/services/internal-settings/internal-settings.interface';
import { InternalSettingsService } from 'src/app/common/services/internal-settings/internal-settings.service';
import { PAActivity } from 'src/app/common/services/permitted-activity/pa-menu-meta';
import { PRIVATE_ROUTE_PATH } from 'src/app/system/core/private.routes';
import { TranslateUtilityService } from 'src/app/system/utility/translation-utility.service';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';


@Component({
    selector: 'app-base-sidebar-activity',
    templateUrl: './base-sidebar-activity.component.html',
    styleUrls: ['./base-sidebar-activity.component.less'],
    standalone: false
})
export class BaseSidebarActivityComponent implements OnInit {
  @Input() activity!: PAActivity;
  @ViewChild('SidebarlistElement') listEle!: HTMLElement;
  colorTextHeader!: Record<string, string>;
  hover: boolean = false;
  isActive: boolean = false;

  is!: InternalSettings;
  es!: ExternalSettings;

  constructor(
    protected srvIS: InternalSettingsService,
    protected srvES: ExternalSettingsService,
    protected router: Router,
    protected srvActivity: MEActivityService,
    protected cd: ChangeDetectorRef,
    protected translate: TranslateUtilityService) {}

  ngOnInit(): void {
    combineLatest([this.srvIS.getCurrentSettings(), this.srvES.externalSettings$])
    .subscribe(([is, es])=>{
      this.is = is;
      this.es = es;
      this.colorTextHeader = UIUtilityService.getHeaderStyle();
      this.isActive = this.activity.path == this.router.url;
    })
    this.router.events.subscribe((val)=>{
      if (val instanceof NavigationEnd) {
        let currentUrl = this.getCurrentUrl();
        
        if (currentUrl != this.activity.path) {
          if (this.activity.subUrls?.includes(currentUrl)) {
            this.isActive = true;
          } else {
            this.isActive = false;
          }
        } else {
          this.isActive = true;
        }
      }
    })
    this.cd.detectChanges();
  }

  navigateTo() {
    if (this.activity.path !== this.getCurrentUrl()) {
      this.srvActivity.reset();
      this.router.navigateByUrl(this.activity.path || '/dashboard');
    }
  }

  protected getCurrentUrl(): string {
    return '/' + this.router.parseUrl(this.router.url.substring(('/' + PRIVATE_ROUTE_PATH).length)).root.children['primary']?.segments.map(it => it.path).join('/');
  }

  public configure(activity: PAActivity) {
    this.activity = activity;
  }
}
